import Me from '@images/me/about.jpg';

export const aboutData = {
    id : "ez7mz",
    experience: "+1 Year Working",
    projectCompleted: "+10 Projects",
    supportTime: "Monday to Friday",
    about: "Bridging data engineering and AI, I design scalable systems that transform raw data into actionable intelligence. From robust ETL pipelines to optimized workflows, I ensure accuracy, efficiency, and reliability—laying the foundation for machine learning and data-driven innovation.",
    image: Me
};